import { getSystemInfo, compareVersion } from '@/utils/wx_api'

const getBuildingUrl = (house) => {
    return house && house.usage === '商业' ? '/building/business' : '/building'
}

const handleHouseUrl = (house) => {
    let href = getBuildingUrl(house) + '?'
    if (house.building_id) {
        href += `building_id=${house.building_id}&house_id=${house.id}`
    } else {
        href += `building_id=${house.id}`
    }
    return href
}
export const checkBuildingPhoneAuth = (building) => {
    return building && building.activities && building.activities.indexOf('授权手机号') > -1
}
export const handleBusinessHouses = (houses) => {
    houses.forEach(item => {
        item.href = item.href.replace('/building', '/building/business')
    })
}

const handleCommentUrl = (house) => {
    let href = '/building/comments?'
    if (house.building_id) {
        href += `building_id=${house.building_id}&house_id=${house.id}`
    } else {
        href += `building_id=${house.id}`
    }
    return `${href}&name=${house.name}`
}

const is_support_webp = false

console.log('is_support_webp', is_support_webp)

export const enable_webp = false

export const handleImgSize = (img, size_w, size_h ) => {

    if (!img) {
        return ''
    }
    const index = img.indexOf('?')
    let format = '/format,jpg'
    if (index > -1) {
        img = `${img.substring(0, index)}`
    }
    if (enable_webp) {
        format = `/format,webp`
    }
    let size = '/resize'
    if (size_w) {
        size += `,w_${size_w}`
    }
    if (size_h) {
        size += `,h_${size_h}`
    }
    return `${img}?x-oss-process=image${size}${format}`
}

export const handleBuidingBanner = (img) => {
    return handleImgSize(img, 750, 500)
}

export const handleBuidingMiniBanner = (img) => {
    const index = img.indexOf('?')
    if (index > -1) {
        img = img.substring(0, index + 1)
    }
    return handleImgSize(img, 210, 140)
}

export const handlePhotoUrl = (img, show_default = true) => {
    return img ? handleImgSize(img, 210, 140, {})
            :
    (show_default ? 'https://cdn.vip-wifi.com/fangchan/img/default-img-normal.jpeg' : '')
}

export const handleWxHeadimg = (item, size) => {
    if (item.weixin_headimgurl && item.weixin_headimgurl.indexOf('https://cdn.vip-wifi.com') === 0) {
        item.weixin_headimgurl = handleImgSize(item.weixin_headimgurl, size, size)
    }
}

export const filterData = data => {
    const keys = Object.keys(data)
    const whilte_keys = ['log_id']
    keys.filter((key) => whilte_keys.indexOf(key) === -1)
        .forEach(key => {
            const value = data[key]
            if (value === undefined || value === null || value === '') {
                delete data[key]
            }
        })
    return data
}

const handleTag = (tag) => {
    if (tag === '即将取证') {
        tag = '即将预售'
    }
    const tag2class = [
        {
            class_name: 'vr',
            tags: ['VR售楼部', '楼盘航拍']
        },
        {
            class_name: 'green',
            tags: ['摇号完成', '摇号结果', '正在登记', '在售', '等待摇号', '即将预售'],
            type: 'status'
        }
    ]
    let tag_class = ''
    let tag_type = ''
    tag2class.some(({ tags, class_name, type }) => {
        if (tags.indexOf(tag) > -1) {
            tag_class = class_name
            tag_type = type
            return true
        }
    })
    return {
        name: tag,
        tag_class,
        tag_type
    }
}

export const getTags = (house) => {
    let tags = []
    if (house.tag_list) {
        tags = house.tag_list.slice(0)
    }
    if (!house.hide_status) {
        const { status, data_status: dataStatus } = house
        if (status) {
            tags.push(status)
        }
        if (dataStatus) {
            tags.push(dataStatus)
        }
    }
    const rules = ['vr', 'green', '']
    return tags.map(handleTag).sort((a, b) => {
        return rules.indexOf(a.tag_class) - rules.indexOf(b.tag_class)
    }).filter(({ tag_class }) => tag_class != 'vr')
}

export const handleViewCount = (view_count) => {
    return view_count >= 10000 ? `${(view_count / 10000).toFixed(1)}w` : view_count
}

export const handlePrice = (item) => {
    item.price_desc_arr = item.customized_price && item.customized_price.length ?
        item.customized_price
        :
        item.price_desc ? item.price_desc.split(',') : []
}

const getTag = (house) => house.tag_list && house.tag_list.length ? house.tag_list[0] : house.zone

export const mapHouseItem = house => {
    let houseItemData = filterData(house)
    const tags = getTags(house)
    const status_tags = tags.filter(({ tag_class }) => tag_class === 'green')
    handlePrice(houseItemData)
    const { visit_reservation_tip } = house
    const tips = visit_reservation_tip ? visit_reservation_tip.split('，') : []
    const visit_reservation = tips && tips.length ? tips[0] : ''
    if (house.vr_resource && house.vr_resource.vr_photo_url) {
        house.vr_resource.vr_photo_url = handlePhotoUrl(house.vr_resource.vr_photo_url)
    }
    houseItemData = {
        ...houseItemData,
        visit_reservation,
        href: handleHouseUrl(house),
        comment_href: handleCommentUrl(house),
        cover_photo_url: handlePhotoUrl(house.cover_photo_url),
        surplus_img_url: house.cover_photo_url,
        tags,
        tag: getTag(house),
        view_count: handleViewCount(house.view_count),
        date_with_status: house.date_with_status && house.date_with_status.replace(/-/g, '.'),
        ...['common_probability', 'rd_probability'].reduce((obj, key) => {
            const value = house[key]
            if (value) {
                obj[key] = value
            }
            return obj
        }, {})
    }

    if (house.hide_status && status_tags.length) {
        houseItemData.status = status_tags[0].name
    }

    houseItemData.building_id = houseItemData.building_id || houseItemData.id

    delete houseItemData.id
    delete houseItemData.min_price
    delete houseItemData.max_price

    return houseItemData
}

export const mapHouseDetail = house => {
    filterData(house)
    house.current_houses = house.current_houses || []
    handlePrice(house)
    house.current_houses.forEach((item) => {
        handlePrice(item)
    })
    return house
}

export const handleHomeHouses = (houses) => {
    return houses.map((item) => {
        const { id, target, position, content, photo_url, listpage_order } = item
        const house = mapHouseItem(target)
        house.photo_url = handlePhotoUrl(photo_url, false)
        house.href = handleBannerHref(item)
        house.content = content
        house.position = position
        house.log_id = id
        house.listpage_order = listpage_order || null
        return house
    })
}

export const handleCol3 = (houses) => {
    return houses.map((house) => {
        return {
            ...house,
            tag: getTag(house)
        }
    })
}

export const handleHouseViewData = (houses) => {
    houses = handleHomeHouses(houses).slice(0, 4)
    if (houses.length === 1 || houses.length === 4) {
        return {
            col_1: [
                houses[0]
            ],
            col_3: handleCol3(houses.slice(1))
        }
    }
    if (houses.length === 2) {
        return {
            col_1: [
                houses[0],
                houses[1]
            ],
            col_3: []
        }
    }
    if (houses.length === 3) {
        return {
            col_1: [],
            col_3: handleCol3(houses)
        }
    }
}

export const handleSurplusItemHref = (id) => {
    return '/building?building_id=' + id + '&from=surplus_buildings'
}

export const handleSurplusItem = (item, i) => {
    if (!item.hide_status) {
        item.tag_list.unshift('在售')
    }
    item.tags = getTags(item)
    handlePrice(item)
    item.href = handleSurplusItemHref(item.id)
    item.view_count = handleViewCount(item.view_count)
    item.cover_photo_url = handleImgSize(item.cover_photo_url, 216, 144)
}

export const handleBannerHref = (banner) => {
    if (banner.href) {
        const id = banner.target.id
        if (/\.png|jpg|jpeg|gif|webp$/.test(banner.href.toLowerCase())) {
            return `/pages/activity_a/thematic/activity/main?photo_url=${banner.href}`
        }
        if (banner.href.indexOf('/pages') === 0) {
            return banner.href
        }
        if (banner.href.indexOf('https') === 0 || banner.href.indexOf('http') === 0) {
            return `/web_page?building_id=${id}&type=custom&title=${process.env.APP_NAME}&link=${encodeURIComponent(banner.href)}`
        }
        return ''
    }
    const buildingHref = handleHouseUrl(banner.target)
    if (banner.consultant_group_id) {
        return `${buildingHref}&consultant_group_id=${banner.consultant_group_id}`
    }
    return buildingHref
}

export const getBannerOpenType = (banner) => {
    return 'navigateTo'
}

export const handleBanner = (banners) => {
    return banners.map(banner => {
        return {
            id: banner.id,
            photo_url: handleImgSize(banner.photo_url, 750, 280),
            href: handleBannerHref(banner),
            name: banner.content || banner.target.name || '',
            open_type: getBannerOpenType(banner),
            position: banner.position
        }
    })
}

export const handleFloatDlg = (banners) => {
    return banners.map(banner => {
        return {
            id: banner.id,
            photo_url: banner.photo_url,
            href: handleBannerHref(banner),
            name: banner.content || banner.target.name || '',
            open_type: getBannerOpenType(banner),
            position: banner.position
        }
    })
}

export const mapHomePage = data => {
    return {
        homepage_banner: handleBanner(data.homepage_banner),
        dashboard: data.dashboard,
        hot: handleHouseViewData(data.hot),
        forthcoming_sale: handleHouseViewData(data.forthcoming_sale),
        homepage_popup: data.homepage_popup,
        latest_opening: handleHomeHouses(data.latest_opening),
        latest_lot_number: handleHomeHouses(data.latest_lot_number),
        homepage_middle_banner: handleBanner(data.homepage_middle_banner),
        excellent_consultants: data.excellent_consultants,
        surplus: handleCol3(handleHomeHouses(data.surplus))
    }
}
